import React from 'react'
import Button from 'components/Button'
import Container from 'components/Container'

import CirlceCheckboxes from 'components/CircleCheckboxes'
import { useForm } from 'react-hook-form'
import { Yoga_Type_Enum } from 'generated/graphql'
import { useFormCarousel } from 'forms/FormCarousel/context'

const ORDER = [
  Yoga_Type_Enum.Hatha,
  Yoga_Type_Enum.Vinyasa,
  Yoga_Type_Enum.Kundalini,
  Yoga_Type_Enum.Ashtanga,
  Yoga_Type_Enum.Bikram,
  Yoga_Type_Enum.Iyengar,
  Yoga_Type_Enum.Yin,
  Yoga_Type_Enum.Power,
  Yoga_Type_Enum.Aerial,
  Yoga_Type_Enum.Prenatal,
  Yoga_Type_Enum.Postnatal,
  Yoga_Type_Enum.Nidra,
]

const getOptions = (order: string[], options: string[]) => {
  const missingOptionsInOrder = options.filter(
    (option) => option !== Yoga_Type_Enum.Other && !order.includes(option),
  )

  return [...order, ...missingOptionsInOrder, Yoga_Type_Enum.Other]
}

const YogaTypes = () => {
  const { next, initialValues } = useFormCarousel()
  const { control, handleSubmit } = useForm({
    defaultValues: {
      yogaTypes: initialValues?.yogaTypes || '',
    },
  })

  return (
    <Container topBottomSpace className="flex flex-col min-h-full">
      <div className="h-14 text-center">
        <div className="heading-1 text-primary">
          What are your favorite
          <br />
          styles of yoga?
        </div>
      </div>

      <form
        onSubmit={handleSubmit((values) => {
          next(values)
        })}
        className="flex flex-col flex-grow justify-center py-8"
        id="form-yoga-types"
      >
        <CirlceCheckboxes
          control={control}
          name="yogaTypes"
          grid={{
            colums: 3,
            gap: 3,
          }}
          options={getOptions(ORDER, Object.values(Yoga_Type_Enum))}
          $textSize="xs"
          squared
        />
      </form>

      <Button $fluid form="form-yoga-types">
        Next
      </Button>
    </Container>
  )
}

export default YogaTypes
